module.exports = __webpack_public_path__ + "assets/img/thumbnail1-2b4a0618.png";